import { render } from "./PlayCard.vue?vue&type=template&id=715c7f72&scoped=true"
import script from "./PlayCard.vue?vue&type=script&lang=js"
export * from "./PlayCard.vue?vue&type=script&lang=js"

import "./PlayCard.vue?vue&type=style&index=0&id=715c7f72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-715c7f72"

export default script